import gsap from 'gsap'

export function initDrawPath(): void {
  // Get the mask path (used for the draw animation)
  const maskPath = document.getElementById('draw-path-mask') as SVGPathElement | null

  if (!maskPath) return

  // Get the total length of the path
  const pathLength = maskPath.getTotalLength()

  // Set initial state - hide the path by offsetting the mask stroke
  maskPath.style.strokeDasharray = `${pathLength}`
  maskPath.style.strokeDashoffset = `${pathLength}`

  // Animate the mask path on scroll to reveal the dashed line
  gsap.to(maskPath, {
    strokeDashoffset: 0,
    ease: 'none',
    scrollTrigger: {
      trigger: '.letter__connector',
      start: 'top 30%',    // Start when connector is near middle of viewport
      end: 'bottom 10%',   // End when connector is almost at bottom
      scrub: true,
    },
  })
}
